import React from 'react'

import Layout from '../../components/Layout'
import EmptyState from '../../components/EmptyState'

const NotAuthorized = () => {
  return (
    <Layout isSidebar={true}>
      <input type="text" />
      <EmptyState label="You do not have access to this page. Please contact your system administrator for access." />
    </Layout>
  )
}

export default NotAuthorized
